export enum InvoiceTotalPriceColumns {
  Both = 'total,netTotal',
  Gross = 'total',
  Net = 'netTotal',
}
